module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart-layout', {
    attrs: {
      "title": _vm.title,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.xAxis
    }
  }, [_c('bar-graph', {
    attrs: {
      "chart-data": _vm.data,
      "chart-id": _vm.chartIdOverride,
      "labelFunc": _vm.displayLabel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5ac99f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/graphs/IncomeGraph.vue
// module id = 1999
// module chunks = 0